import "./styles.css";
import React, { useEffect, useState } from "react";
import logoEstado from "../../assets/img/logo-ms-gov-branca.svg";
import { useHistory } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as PermissaoAction from "../../redux/actions/permissao";

interface HeaderProps {
  permissaoAcesso?: any;
  setPermissaoAcesso?: any;
}

const Header: React.FC<HeaderProps> = (props) => {
  const history = useHistory();
  const [rota, setRota] = useState("");

  useEffect(() => {
    let string = history.location.pathname.substring(1);
    let finalDaPalavra =
      string.search("/") != -1 ? string.search("/") : string.length;
    setRota(
      string.substring(0, finalDaPalavra).toUpperCase().replace("-", " "),
    );
    verificarPermissaoRota(string.substring(0, finalDaPalavra).toUpperCase());
  }, []);

  const verificarPermissaoRota = (rota: string) => {
    let menus: any[] = JSON.parse(sessionStorage.getItem("modulos") || "[]");

    if (menus.length > 0) {
      let menu: any = menus.find((m) =>
        m.navegarURL
          .trim()
          .toLowerCase()
          .replace(" ", "")
          .includes(rota.trim().replace(" ", "").toLowerCase()),
      );
      if (menu == null) {
        history.replace("/error", {
          mensagem: "Usuário não possui permissão ao módulo.",
        });
      } else {
        props.setPermissaoAcesso(menu.permissao);
      }
    } else if (history.location.pathname !== "/error") {
      history.replace("/error", {
        mensagem: "Usuário não possui permissão ao módulo.",
      });
    }
  };

  return (
    <div className="header">
      <nav id="custom-nav" className="headerNav">
        <form className="logoEstado" id="form_header">
          <div>
            <img className="imgLogoEstado" src={logoEstado}></img>
          </div>
          <span className="titulo-sistema">CADMI-MS</span>
          {/* <button id="btn-novo" className="custom-btn btn btn-success" type="submit">
                        <a href="cadastro.html">+ Novo</a>
                    </button> */}
        </form>
        {/* <div className="imigrantes-logo">   
                     <img src={logo-header} className="logoHeader"/>                     
                </div> */}

        {/* <div className="info_perfil">
                    <span>{usuario.nomeUsuario}
                        <br />{grupo}
                        <br /> {geoEstrutura}</span>
                </div> */}
        {/* <div className="btn-perfil-info">
                    <button className="btn custom-info-btn" id="info-mob" type="button" data-toggle="collapse" data-target="#info-mobile">
                        <span>Usuário</span>
                        <div className="collapse" id="info-mobile">
                            <div>
                                <span>{usuario.nomeUsuario}
                                    <br />{grupo}
                                    <br /> {geoEstrutura}</span>
                            </div>
                        </div>
                    </button>
                </div> */}
      </nav>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  permissaoAcesso: state.permissaoAcesso,
});

const mapDispatcToProps = (dispatch: any) =>
  bindActionCreators(PermissaoAction, dispatch);

export default connect(mapStateToProps, mapDispatcToProps)(Header);
